export default __webpack_public_path__ + "static/assets/finalized-order-confetti.e5c193d7.png";